import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Keyboard } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

export const initEntryCarousel = () => {
  const swiperElements = document.querySelectorAll('.entry-carousel');

  for (let i = 0; i < swiperElements.length; i++) {
    const element = swiperElements[i];
    
    if (!element.id) {
      element.id = `entry-carousel-${i}`;
    }
    
    let nextButton = element.querySelector('.swiper-button-next');
    let prevButton = element.querySelector('.swiper-button-prev');
    
    if (!nextButton || !prevButton) {
      const swiperSection = element.closest('section');
      if (swiperSection) {
        nextButton = nextButton || swiperSection.querySelector('.swiper-button-next');
        prevButton = prevButton || swiperSection.querySelector('.swiper-button-prev');
      }
    }
    
    const swiperInstance = new Swiper(`#${element.id}`, {
      modules: [Pagination, Keyboard, Navigation],
      slidesPerView: "auto",
      spaceBetween: 20,
      breakpoints: {
        768: {
          spaceBetween: 32
        },
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
    });
    
    element.swiperInstance = swiperInstance;
  }
};